export const getFilterPropertyValues = (commitOptions, allFilterDefs) => {
  const appliedFilters = [];
  Object.entries(commitOptions !== null && commitOptions !== void 0 ? commitOptions : {}).forEach(_ref => {
    let [filterId, options] = _ref;
    if (!(options !== null && options !== void 0 && options.length)) {
      return;
    }
    const filterDefinition = allFilterDefs.find(def => def.filterId === filterId);
    const filterLabel = (filterDefinition === null || filterDefinition === void 0 ? void 0 : filterDefinition.label) || filterId;
    const values = options.map(option => option.label);
    if (values.length > 0) {
      appliedFilters.push({
        '@type': 'PropertyValue',
        name: filterLabel,
        value: values.join(', ')
      });
    }
  });
  return appliedFilters;
};